import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { dispatchPostConnections } from '../../actions/PostActions.js';
import TravelogueBoard from './TravelogueBoard.js';
import * as Const from '../../Const';

const CONNECT_TYPE_TRAVELOGUE_LIST = 'travelogue/list';
const NUMBER_PER_READING = 20;

class TravelogueList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentNumber: 0, // 読込済件数
            totalNumber: 0,   // 全件数
            loadingState: true
        };

        this.travelogue_info = [];

        this.handleConnect  = this.handleConnect.bind(this);
        this.handleConnectChange = this.handleConnectChange.bind(this);
        this.handleConnect();
    }

    handleConnect() {
        let params = {
            current_number: this.state.currentNumber,
            reading_number: NUMBER_PER_READING
        };
        if (this.props.editable) {
            params.contributor_id = localStorage.getItem('user_id');
        } else {
            params.is_draft = 0;
        }
        
        this.props.dispatch(dispatchPostConnections(CONNECT_TYPE_TRAVELOGUE_LIST, params, this.handleConnectChange));
    }

    handleConnectChange(type, data, status) {
        this.setState({loadingState: false});

        if (status !== Const.CONNECT_SUCCESS) {
            let sampleData = {
                travelogue_id: '1',
                matching_id: '',
                flight_time_fee: '210',
                total_cost: '284782',
                flight_start_date: '',
                flight_end_date: '',
                contributor_id: '',
                contributor_name: '',
                aircraft_name: '',
                guests: '',
                travelogue_title: '日帰りセスナ旅行【名古屋⇔能登半島】',
                travelogue_tags: 'セスナ 小型航空機 名古屋空港 能登空港 夜景\u00a0',
                travelogue_cover: Const.TRAVELOGUE_URL+'1/cover.jpg',
                file_content: Const.TRAVELOGUE_URL+'1/travelogue.pdf',
                is_draft: '0',
                sort_order: '',
                deleted_at: '',
                created_at: '',
                updated_at: ''
            };
            this.travelogue_info = [sampleData];
            this.setState({currentNumber: 1, totalNumber: 1});
            return;
        }

        if (data.data.length) {
            this.travelogue_info = this.travelogue_info.concat(data.data);
            this.setState({currentNumber: this.state.currentNumber + data.data.length});
        } else {
            this.setState({totalNumber: this.state.currentNumber});
        }
    }

    render() {
        let dummy = [];
        for (let i = this.travelogue_info.length % this.props.divisor; i > 0 && i < this.props.divisor; i++) {
            dummy.push(<TravelogueBoard key={'travelogue_dummy'+i} />);
        }

        return <React.Fragment>
            <div style={styles.background}>
                <div style={styles.container}>
                    {this.travelogue_info.map((data, i) => {
                        if (data.travelogue_cover && data.travelogue_cover.indexOf(Const.TRAVELOGUE_URL) < 0) data.travelogue_cover = Const.TRAVELOGUE_URL+data.travelogue_id+'/'+data.travelogue_cover;
                        if (data.file_content && data.file_content.indexOf(Const.TRAVELOGUE_URL) < 0) data.file_content = Const.TRAVELOGUE_URL+data.travelogue_id+'/'+data.file_content;
                        return <TravelogueBoard data={data} key={'travelogue_id'+data.travelogue_id} />
                    })}
                    {dummy}
                </div>
            </div>
        </React.Fragment>;
    }
}

const styles = {
    background: {
        /*background: '#FFF',*/
        // paddingTop: 24,
        paddingBottom: 48
    },
    container: {
        display: 'flex',
        justifyContent: 'space-around',
        flexWrap: 'wrap'
    }
}

TravelogueList.propTypes = {
    editable: PropTypes.bool,
    divisor: PropTypes.number
}

export default connect()(TravelogueList);


// WEBPACK FOOTER //
// ./src/components/Travelogue/TravelogueList.js